import { render, staticRenderFns } from "./candidate-document-form.vue?vue&type=template&id=5c9610ff&"
import script from "./candidate-document-form.vue?vue&type=script&lang=js&"
export * from "./candidate-document-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports